var NOTIFICATION_VARIANT;
(function (NOTIFICATION_VARIANT) {
    NOTIFICATION_VARIANT["SUCCESS"] = "success";
    NOTIFICATION_VARIANT["CRITICAL"] = "critical";
    NOTIFICATION_VARIANT["WARNING"] = "warning";
    NOTIFICATION_VARIANT["NEUTRAL"] = "neutral";
    NOTIFICATION_VARIANT["PROMO"] = "promo";
})(NOTIFICATION_VARIANT || (NOTIFICATION_VARIANT = {}));
export { NOTIFICATION_VARIANT };
